import { render, staticRenderFns } from "./GenesisNodePage.vue?vue&type=template&id=9a6612a6&scoped=true"
import script from "./GenesisNodePage.vue?vue&type=script&lang=js"
export * from "./GenesisNodePage.vue?vue&type=script&lang=js"
import style0 from "./GenesisNodePage.vue?vue&type=style&index=0&id=9a6612a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6612a6",
  null
  
)

export default component.exports